import { useContext, useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { Link } from "react-router-dom";
import { ReactComponent as CheckBoxIcon } from "../../../../assets/img/icon/check_box_black_24dp.svg";
import { ReactComponent as ChevronRight } from "../../../../assets/img/icon/chevron_right_black_24dp.svg";
import { ReactComponent as Description } from "../../../../assets/img/icon/description_black_24dp.svg";
import { ReactComponent as Descriptiont } from "../../../../assets/img/icon/description_black_24dpt.svg";
import { ReactComponent as CheckBoxIconBlank } from "../../../../assets/img/icon/disabled_by_default_black_24dp.svg";
import { ReactComponent as EditIcon } from "../../../../assets/img/icon/edit_black_24dp.svg";
import { ReactComponent as People } from "../../../../assets/img/icon/people_black_24dp.svg";
import { ReactComponent as PersonDeleteIcon } from "../../../../assets/img/icon/person_off_black_24dp.svg";
import { ReactComponent as RadioChecked } from "../../../../assets/img/icon/radio_button_checked_black_24dp.svg";
import { ReactComponent as RadioUnchecked } from "../../../../assets/img/icon/radio_button_unchecked_black_24dp.svg";
import { COLOR } from "../../../../config/constant";
import { getDateFormat } from "../../../../helpers/helper";
import { Patient } from "../../../../models/Patient";
import { Record } from "../../../../models/Record";
import {
  deletePatient,
  getPatientDetail,
} from "../../../../services/httpService/patientRequest";
import {
  deleteRecord,
  getRecord,
} from "../../../../services/httpService/recordRequest";
import { GlobalContext } from "../../../contexts/globalContext";
import AnimatedBlock from "../../../ui/atoms/AnimatedBlock/AnimatedBlock";
import Button from "../../../ui/atoms/Button/Button";
import CardDashboard from "../../../ui/atoms/CardDashboard/CardDashboard";
import ExpandData from "../../../ui/atoms/ExpandData/ExpandData";
import PageTitle from "../../../ui/atoms/PageTitle/PageTitle";
import PatientInfo from "../../../ui/atoms/PatientInfo/PatientInfo";
import ModalPatientEdit from "../../../ui/organisms/ModalPatientEdit/ModalPatientEdit";

const LIMIT = 5;
const dateNow = getDateFormat(new Date());

const PatientDetail = () => {
  const isMounted = useRef(true);
  const [sharedState, dispatch] = useContext(GlobalContext);
  const params = useParams();
  const [state, setState] = useState({
    page: 1,
    tpage: 0,
    count: 0,
    startDate: "",
    endDate: "",
  });

  const [selectedRecord, setSelectedRecord] = useState([]);

  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [patient, setPatient] = useState();
  const [records, setRecords] = useState(new Array(LIMIT).fill(0));
  const [modal, setModal] = useState(null);
  const [isComparable, setIsComparable] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleDeleteAction = () => {
    const reducedRecords = selectedRecord.reduce((prev, curr, idx) => {
      if (idx !== 0) return `${prev},${curr}`;
      return curr;
    }, "");
    dispatch("confirm", {
      show: true,
      message: `Lanjutkan hapus rekam medis yang terpilih?`,
      callback: () => handleDeleteRecord(reducedRecords),
    });
  };

  const handleGetPatient = async () => {
    try {
      let { result } = await getPatientDetail(
        `${params.id}?doctor=${sharedState.user._id}`
      );
      if (result === null) throw new Error("Invalid request");
      result = new Patient(result._id, result.user.name, result.user.profile);
      if (isMounted.current) setPatient(result);
    } catch (error) {
      dispatch("alert", {
        message: `Pasien ID : "${params.id}" tidak ditemukan`,
        show: true,
        type: "warning",
      });
      history.push("/patient");
    }
  };

  const handleGetRecord = async (data) => {
    try {
      let offset = 0;
      let page = state.page;
      if (data === "next") {
        page += 1;
        if (isMounted.current)
          setRecords((prevState) => [...prevState, new Array(LIMIT).fill(0)]);
      } else if (data === "prev") {
        page -= 1;
      } else if (data === "refresh") {
        page = 1;
        if (isMounted.current) setRecords(new Array(LIMIT).fill(0));
      }
      offset = (page - 1) * LIMIT;
      let param = `patient=${params.id}&limit=${LIMIT}&offset=${offset}&fields=createdAt,testNumber,notes,device,mode`;

      if (state.startDate !== "")
        param = `${param}&startDate=${state.startDate}`;

      if (state.endDate !== "") param = `${param}&endDate=${state.endDate}`;

      if (state.startDate !== "" && state.endDate !== "") {
        if (new Date(state.startDate) > new Date(state.endDate)) {
          dispatch("alert", {
            show: true,
            message: "Interval waktu salah",
            type: "warning",
          });
          return;
        }
      }

      setLoading(true);
      let { result, count } = await getRecord(param);
      const tpage = Math.ceil(count / LIMIT);

      result = result.map(
        (res) =>
          new Record(
            res._id,
            res.createdAt,
            res.device,
            res.mode,
            res.patient,
            res.notes,
            res.testNumber
          )
      );

      if (page !== 1) result = [...records, ...result];
      if (!isMounted.current) return null;
      setRecords(result);
      setState((prevState) => ({ ...prevState, tpage, page, count }));
      setLoading(false);
    } catch (error) {
      if (!isMounted.current) return null;
      console.log(error.message);
      setLoading(false);
    }
  };

  const handleChangePage = (path) => {
    history.push(path);
  };

  const handleConfirmDelete = () => {
    dispatch("confirm", {
      show: true,
      message: `Menghapus data pasien akan berdampak terhapusnya riwayat rekam medis pasien. Lanjutkan? `,
      callback: () => handleDeletePatient(),
    });
  };

  const handleDeletePatient = async () => {
    try {
      dispatch("confirm", {
        show: false,
        message: null,
        callback: null,
      });
      dispatch("isLoading", true);
      await deletePatient({
        _id: params.id,
      });
      dispatch("isLoading", false);
      history.push("/patient");
    } catch (error) {
      if (!isMounted.current) return null;
      dispatch("isLoading", false);
      dispatch("alert", {
        show: true,
        message: error.message,
        type: "warning",
      });
    }
  };

  const handleDeleteRecord = async (_id) => {
    try {
      dispatch("confirm", {
        show: false,
        message: null,
        callback: null,
      });
      dispatch("isLoading", true);
      await deleteRecord({ _id: _id });
      setSelectedRecord([]);
      if (!isMounted.current) return;
      handleGetRecord("refresh");
      dispatch("isLoading", false);
    } catch (error) {
      if (!isMounted.current) return null;
      dispatch("isLoading", false);
      dispatch("alert", {
        show: true,
        message: error.message,
        type: "warning",
      });
    }
  };

  const selectToggler = (recordId) => {
    let updatedRecords = [...selectedRecord];
    if (!updatedRecords.includes(recordId)) {
      updatedRecords = [...updatedRecords, recordId];
    } else {
      updatedRecords = updatedRecords.filter((record) => record !== recordId);
    }
    setSelectedRecord(updatedRecords);

    if (updatedRecords.length <= 1) {
      setIsComparable(false);
      return;
    }

    let mode = "";
    let isComparable = true;
    records.forEach((record, idx) => {
      if (!updatedRecords.includes(record._id)) return;
      if (mode === "") mode = record.mode;
      if ((isComparable && mode !== record.mode) || mode === "basic")
        isComparable = false;
    });
    setIsComparable(isComparable);
  };

  const handleCompare = async () => {
    try {
      const MAX_RECORD = 3;
      if (selectedRecord.length <= 1)
        throw new Error("Silakan pilih minimal 2 rekam medis");
      if (selectedRecord.length > MAX_RECORD)
        throw new Error("Melebihi batas maksimum rekam medis");
      const concatRecord = selectedRecord.reduce((prev, curr, idx) => {
        if (idx === 0) return curr;
        return `${prev},${curr}`;
      }, "");
      history.push(
        `/patient/${params.id}/record-comparison?data=${concatRecord}`
      );
    } catch (error) {
      if (!isMounted.current) return null;
      dispatch("alert", {
        show: true,
        message: error.message,
        type: "warning",
      });
    }
  };

  const handleGetData = async () => {
    await handleGetPatient();
    await handleGetRecord();
  };

  useEffect(() => {
    handleGetData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      {patient && (
        <ModalPatientEdit
          show={modal === "Edit"}
          handleClose={() => setModal("")}
          handleUpdate={handleGetPatient}
          patient={patient}
        />
      )}
      <div className="mt-2 lg:mt-6">
        <PageTitle
          title="Halaman Pasien"
          description="Dapatkan informasi pasien beserta dengan riwayat medisnya."
          icon={
            <People className="w-10 sm:w-12 lg:w-16 h-10 sm:h-12 lg:h-16 fill-current text-white" />
          }
        />
        <PatientInfo patient={patient} className="mt-6" />

        {/* SUBMENU */}
        <div className="mt-10 flex flex-col lg:flex-row justify-start lg:justify-between items-center space-y-4 lg:space-y-0">
          {/* LEFT SUBMENU */}
          <div className="w-full xl:w-2/3 flex flex-wrap">
            <div className="w-full xl:w-2/3 flex space-x-2 items-center mr-2 mt-2">
              <div className="text-primary font-medium flex-shrink-0 hidden lg:block">
                Periode :
              </div>
              <input
                className="w-1/2 md:w-40 border-b border-primary text-primary px-1 focus:outline-none"
                type="date"
                name="startDate"
                placeholder="yyyy-mm-dd"
                value={state.startDate}
                onChange={handleChange}
                max={dateNow}
              />
              <span>-</span>
              <input
                className="w-1/2 md:w-40 border-b border-primary text-primary px-1 focus:outline-none"
                type="date"
                name="endDate"
                placeholder="yyyy-mm-dd"
                value={state.endDate}
                onChange={handleChange}
                min={state.startDate}
                max={dateNow}
              />
              <Button
                className="w-1/4 md:w-24 flex-shrink-0 bg-primary rounded px-2 py-1 text-sm text-white focus:outline-none focus:ring-2"
                handleClick={() => handleGetRecord("refresh")}
              >
                Cari
              </Button>
            </div>
          </div>
          {/* RIGHT SUBMENU */}
          <div className="w-full xl:w-1/3 flex space-x-2 justify-end mt-3 lg:mt-0">
            <Link to={`/patient/${params.id}/statistic`}>
              <div className="text-primary cursor-pointer flex items-center ">
                <div>
                  <Descriptiont fill={COLOR.PRIMARY} className="w-6 h-6" />
                </div>
                <div className="ml-1 border-b border-transparent hover:border-primary">
                  Statistik
                </div>
              </div>
            </Link>

            <div
              className="text-primary cursor-pointer flex items-center "
              onClick={() => setModal("Edit")}
            >
              <div>
                <EditIcon fill={COLOR.PRIMARY} className="w-6 h-6" />
              </div>
              <div className="ml-1 border-b border-transparent hover:border-primary">
                Ubah
              </div>
            </div>
            <div
              className="text-primary cursor-pointer flex items-center "
              onClick={handleConfirmDelete}
            >
              <div>
                <PersonDeleteIcon fill={COLOR.PRIMARY} className="w-6 h-6" />
              </div>
              <div className="ml-1 border-b border-transparent hover:border-primary">
                Hapus
              </div>
            </div>

            <Link to="/patient">
              <div className=" text-primary cursor-pointer flex items-center ">
                <div>
                  <ChevronRight fill={COLOR.PRIMARY} className="w-6 h-6" />
                </div>
                <div className="ml-1 border-b border-transparent hover:border-primary">
                  Kembali
                </div>
              </div>
            </Link>
          </div>
        </div>

        <div className="mt-10">
          <CardDashboard
            icon={<Description fill={"#fafafa"} className="w-5 h-5" />}
            title="Rekam Medis"
          >
            <div className="relative pt-8">
              {!loading &&
                (records.length !== 0 ? (
                  <div className="absolute top-2 left-0 right-0">
                    <div className="relative flex">
                      {selectedRecord.length !== 0 && (
                        <div className="flex space-x-2">
                          <div>Aksi : </div>
                          <button
                            className="px-1.5 rounded-md border bg-warning text-white focus:outline-none focus:ring-2 mr-2 text-sm"
                            onClick={handleDeleteAction}
                          >
                            Hapus
                          </button>
                          {isComparable && (
                            <button
                              className="px-1.5 rounded-md border bg-success text-white focus:outline-none focus:ring-2 mr-2 text-sm"
                              onClick={handleCompare}
                            >
                              Bandingkan
                            </button>
                          )}
                        </div>
                      )}
                      <div className="absolute top-0 right-0 text-gray-800 text-opacity-50 text-sm">
                        <span className="hidden md:inline-block">
                          Menampilkan
                        </span>{" "}
                        {records.length} dari {state.count} data
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <p>Tidak ada rekam medis pasien.</p>
                  </>
                ))}

              <div>
                {records.length !== 0 && (
                  <>
                    <div className="overflow-x-auto">
                      <table className="w-full my-3">
                        <thead>
                          <tr className="bg-secondary text-white">
                            <th className="px-2 py-2 text-left border border-white w-6 bg-primary">
                              #
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Tanggal / Waktu
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Tes Ke-
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Mode
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Perangkat
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Review
                            </th>
                            <th className="px-2 py-2 text-left border border-white">
                              Aksi
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {records.map((record, idx) => {
                            if (record._id === undefined)
                              return (
                                <tr className="" key={"dummy-record-" + idx}>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                  <td className="px-1 py-1.5">
                                    <AnimatedBlock className="h-6" />
                                  </td>
                                </tr>
                              );
                            return (
                              <tr
                                className={idx % 2 === 0 ? "bg-gray-100" : ""}
                                key={"record-" + record._id}
                              >
                                <td
                                  className="px-2 py-1.5 border-t cursor-pointer"
                                  onClick={() => selectToggler(record._id)}
                                >
                                  {selectedRecord.includes(record._id) ? (
                                    <RadioChecked className="w-3 h-3 fill-current text-primary" />
                                  ) : (
                                    <RadioUnchecked className="w-3 h-3 fill-current text-primary" />
                                  )}
                                </td>
                                <td className="px-2 py-1.5 border-t">
                                  {record.createdAt}
                                </td>
                                <td className="px-2 py-1.5 border-t">
                                  {record.testNumber}{" "}
                                </td>
                                <td className="px-2 py-1.5 border-t">
                                  {record.mode}
                                </td>
                                <td className="px-2 py-1.5 border-t">
                                  {record.device}
                                </td>
                                <td className="px-2 py-1.5 border-t">
                                  {record.isReviewed ? (
                                    <CheckBoxIcon className="w-5 h-5 fill-current text-primary" />
                                  ) : (
                                    <CheckBoxIconBlank className="w-5 h-5 fill-current text-gray-400" />
                                  )}
                                </td>
                                <td
                                  className="px-2 py-1.5 border-t"
                                  style={{
                                    tableLayout: "fixed",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Button
                                    className="px-1.5 py-0.5 rounded-md border border-secondary text-secondary"
                                    handleClick={() =>
                                      handleChangePage(
                                        `/patient/${params.id}/${record._id}`
                                      )
                                    }
                                  >
                                    Lihat
                                  </Button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <ExpandData
                      page={state.page}
                      tpage={state.tpage}
                      loading={loading}
                      handleMoreData={() => handleGetRecord("next")}
                    />
                  </>
                )}
              </div>
            </div>
          </CardDashboard>
        </div>
      </div>
    </>
  );
};

export default PatientDetail;
